'use strict';

const _=require("pulsar-utils/dist-es6/_");
const ex=require("pulsar-utils/dist-es6/ex");

class GroupThresholdUtilities{
static getRelevantThresholdsFor(personId,flattenedGroups,organizationDefaults){
const directGroups=flattenedGroups.filter(group=>_.includes(group.personIds.map(_.toString),_.toString(personId)));

if(directGroups.length===0){
return{
groupMemberships:[organizationDefaults],
fatigueThreshold:organizationDefaults.fatigueThreshold,
deviationThreshold:organizationDefaults.deviationThreshold};

}

directGroups.forEach(group=>{
group.fatigueThreshold=ex(group.fatigueThreshold).otherwise(organizationDefaults.fatigueThreshold);
group.deviationThreshold=ex(group.deviationThreshold).otherwise(organizationDefaults.deviationThreshold);
});

const fatigueSort=g=>g.fatigueThreshold;
const deviationSort=g=>-g.deviationThreshold;

const groupsSortedByFatigueThreshold=_.sortBy(directGroups,fatigueSort);
const groupsSortedByDeviationThreshold=_.sortBy(groupsSortedByFatigueThreshold,deviationSort);

return{
groupMemberships:_.sortBy(directGroups,[fatigueSort,deviationSort]),
fatigueThreshold:groupsSortedByFatigueThreshold[0].fatigueThreshold,
deviationThreshold:groupsSortedByDeviationThreshold[0].deviationThreshold};

}}


module.exports=GroupThresholdUtilities;
//# sourceMappingURL=groupThresholdUtilities.js.map
